import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { App } from "./app/App"
// Side effect: sets <html data-layout> from the layout decision before first paint
import "./shared/hooks/useBreakpoint"

// i18n — must be imported before any component that uses useTranslation
import "./i18n/i18n"

// Fontsource Variable fonts — subset to Latin + Latin-ext only (S9 optimization)
// Drops Cyrillic, Greek, Vietnamese (saves ~85KB in dist)
import "./styles/fonts.css"

import "./styles/globals.css"
import "./styles/tiptap-variables.scss"
import "./styles/_keyframe-animations.scss"

// Early error logger — captures errors BEFORE React mounts.
// Must be imported before any other app code.
import "./shared/telemetry/earlyErrorLogger"

// ---------------------------------------------------------------------------
// Global error handlers — catch Safari/WebKit IndexedDB crashes and reload.
// Registered BEFORE React renders to catch errors during initialization.
// @see dreambase/reference/safari-indexeddb-crashes.md
// ---------------------------------------------------------------------------
import {
  handleIndexedDBError,
  recoverPendingIndexedDBReload,
} from "@/shared/utils/platform/handleIndexedDBError"

// If a background IDB crash happened just before resume/restart, reload once
// on startup to recover automatically (same behavior users expect from v1).
const isRecoveringFromPendingIdbReload = recoverPendingIndexedDBReload()

window.addEventListener("error", (event) => {
  handleIndexedDBError(event.error)
})

window.addEventListener("unhandledrejection", (event) => {
  handleIndexedDBError(event.reason)
})

if (!isRecoveringFromPendingIdbReload) {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}
